import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../component/ui/Button';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import { PageSmallLoader } from '../../../../component/PageLoader';
import { cloneProductMasterGroup, getProductMasterGroupList } from '../../../../services/products';

export default function ProductGroupModel({
	isOpenProductGroupModel,
	setIsOpenProductModel,
	setIsOpenGroupCodeModel,
	setGroupCode,
	setGroupId,
}) {
	const [searchText, setSearchText] = useState('');
	const [isLoader, setLoader] = useState(false);
	const [isLoaderClone, setLoaderClone] = useState(false);
	const [productGroupList, setProductGroupList] = useState([]);
	const [params, setParams] = useState({
		page: 1,
		pageSize: 30,
		search: '',
	});
	const [selectedProductId, setSelectedProductId] = useState(null);
	const isFirstRender = useRef(true);

	const handleClose = () => {
		setIsOpenProductModel(false);
	};

	const toggleProduct = (id) => {
		if (id === selectedProductId) {
			setSelectedProductId(null);
		} else {
			setSelectedProductId(id);
		}
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // ⛔ skip first render
		}
		const debounceTimer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				search: searchText,
			}));
			setSelectedProductId(null);
		}, 500); // ⏱ debounce delay (ms)

		return () => clearTimeout(debounceTimer);
	}, [searchText]);

	const fetchDefaultproductGroupList = async () => {
		try {
			setLoader(true);
			const { product_groups } = await getProductMasterGroupList(params);
			setProductGroupList(product_groups);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	const handleCloneMasterProductGroup = async (id, name) => {
		try {
			if (!selectedProductId) {
				toast.error('Group Id is not defined in group');
				return;
			}
			const group = productGroupList.find((item) => item.id === selectedProductId);
			const data = {
				id: group.id,
				name: group.group_name,
			};
			const res = await cloneProductMasterGroup(data);
			console.log(res);
			if (res.success) {
				const { product_group } = res.data;
				setGroupCode(product_group.code);
				setGroupId(product_group.product_group_id);
				setIsOpenProductModel(false);
				setIsOpenGroupCodeModel(true);
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message);
		}
	};

	useEffect(() => {
		fetchDefaultproductGroupList();
	}, [params]);

	return (
		<Modal
			className="addCardModel"
			title={`Master Products Groups`}
			// secondaryText={`${cardsState.filter((card) => card.is_checked).length} of ${cardsState.length} selected`}
			isOpen={isOpenProductGroupModel}
			onClose={handleClose}
			cancelButton={handleClose}
		>
			<div className="d-flex flex-row gap-4 align-items-center py-4">
				<div className="col">
					<InputField
						label=""
						placeholder="Search"
						type="text"
						autoComplete="off"
						required={false}
						autoFocus={false}
						value={searchText}
						onChange={setSearchText}
					/>
				</div>
				<div
					className="lead text-secondary cursor-pointer"
					onClick={() => {
						setSearchText('');
						setSelectedProductId(null);
					}}
				>
					Reset
				</div>
			</div>
			<div className="text-start py-2 text-muted">Select the master group you want to clone.</div>
			<div style={{ width: '100%', height: '450px', overflow: 'auto' }}>
				{isLoader ? (
					<div className="d-flex justify-content-center">
						<PageSmallLoader />
					</div>
				) : productGroupList.length === 0 ? (
					<div className="text-center py-4 text-muted">No Master Group found.</div>
				) : (
					productGroupList.map((group, index) => (
						<div
							key={index}
							style={{
								display: 'flex',
								alignItems: 'center',
								marginBottom: '10px',
								borderRadius: '8px',
								gap: '10px',
								padding: '8px 11px',
								backgroundColor: '#EDEDF7',
							}}
						>
							<input
								type="checkbox"
								checked={group.id === selectedProductId}
								onChange={(e) => toggleProduct(group.id)}
								style={{ width: '15px', height: '15px', cursor: 'pointer' }}
							/>
							<span className="lead text-secondary">{group.group_name}</span>
						</div>
					))
				)}
			</div>

			<div
				className="d-flex justify-content-end align-items-center gap-4 py-4 right-0"
				style={{ overflow: 'hidden', position: 'static' }}
			>
				<Button
					type="button"
					button="Cancel"
					className="mt-0 px-4 btn-gray relative"
					onClick={handleClose}
				/>
				<Button
					type="button"
					button="Clone"
					disabled={isLoaderClone}
					loader={isLoaderClone}
					className="mt-0 px-4 btn-primary relative"
					onClick={handleCloneMasterProductGroup}
				/>
			</div>
		</Modal>
	);
}
